import React, { useState, useEffect } from 'react';
import { Link, Redirect } from 'react-router-dom';
import userStore from '../../../Stores/User';
import { observer } from 'mobx-react';
import Play from '../../DiscoverNew/Icons/Play.svg';
import Pause from '../../DiscoverNew/Icons/Pause.svg';
import { loadStripe } from '@stripe/stripe-js';
import mixpanel from 'mixpanel-browser';
import loadingIcon from '../../../Assets/loading.gif';
import { createSubscriptionCheckoutSessionWithTrial } from '../../../audiblogsApi';
import queryString from 'query-string';

const STRIPE_API_KEY = process.env.REACT_APP_STRIPE_API_KEY;
const stripePromise = loadStripe(STRIPE_API_KEY);

function ChooseVoice(props) {
  const { idToken } = userStore;

  const [quality, setQuality] = useState('Unreal');
  const [sessionId, setSessionId] = useState(null);
  const params = queryString.parse(props.location.search);
  const app = params.app || '';

  const redirectToCheckout = () => {
    stripePromise.then((stripe) => {
      stripe
        .redirectToCheckout({
          sessionId,
        })
        .then((handleResult) => {
          console.log('handle results');
          handleResult();
        })
        .catch((e) => {
          console.log(e);
        });
    });
  };

  useEffect(() => {
    if (idToken) {
      console.log(idToken)
      // Get Stripe Checkout Session Id
      createSubscriptionCheckoutSessionWithTrial(
        true,
        idToken,
        `/onboarding/quickstart`,
        quality
      )
        .then(function (data) {
          console.log(data)
          setSessionId(data.data.sessionId);
        })
        .catch((e) => {
          console.log(e);
          // alert('Something went wrong. Please try again or contact us.');
        });
    }
  }, [idToken]);

  // useEffect(() => {
  //   const idToken = userStore.idToken;
  //   if (userStore.user.trial_sd || userStore.user.trial_hd) {
  //   }
  // }, [userStore.user]);

  return (
    <div className="center-static">
      <h1 className="headline" style={{ marginBottom: '0px' }}>
        Choose your plan
      </h1>

      <div style={{ display: 'flex' }}>
        <div
          className="pricing-card"
          style={{ marginTop: '15px' }}
        >
          <div className="price-name">Basic</div>
          <div className="price">Free</div>
          <div className="details">
            <div>2,500 words per conversion</div>
            <div>5 conversions per day</div>
            <div>English only</div>
          </div>
          <div
            className="cta-div"
            style={{ position: 'static', marginTop: '24px' }}
          >
            <button className="cta-button" style={{
              background: "transparent",
              border: "1px solid #fff",
            }}>
              <Link
                to={`quickstart`}
                style={{ textDecoration: 'none' }}
              >
                <div>Go Free</div>
              </Link>
            </button>
          </div>
        </div>
        <div
          className="pricing-card"
          style={{ marginTop: '15px' }}
        >
          <div className="price-name">Unlimited</div>
          <div className="price">$89/year</div>
          <div className="details">
            <div>👏 100,000 characters per conversion</div>
            {/* <div>👏 500,000 words per day</div> */}
            <div>👏 English Only </div>
            <div>👏 Easy to cancel anytime</div>
          </div>
          <div
            className="cta-div"
            style={{ position: 'static', marginTop: '24px' }}
          >
            {sessionId ? (
              <a
                className="cta-button"
                style={{ width: "auto" }}
                onClick={(e) => {
                  e.preventDefault();
                  mixpanel.track("Click Go to Checkout");
                  redirectToCheckout();
                }}
              >
                Try for $0.00
              </a>
            ) : (
              <img
                src={loadingIcon}
                style={{ height: "50px" }}
                alt="loading..."
              />
            )}          </div>
        </div>

      </div>

    </div>
  );
}

export default ChooseVoice;
